<template v-if="consumerunit">
  <v-flex md12>
    <material-card color="cyan" title="Dados da Unidade Consumidora" text="">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container py-0>
          <v-layout wrap>
            <v-flex xs4 md1>
              <v-chip
                v-if="type === 'edit'"
                small
                dark
                :color="consumerunit.status | formatUCStatusColor"
                >{{ consumerunit.status || "-" | formatUCStatus }}</v-chip
              >
              <v-chip v-else small dark color="blue">Nova</v-chip>
            </v-flex>
            <v-flex xs8 md5>
              <v-radio-group
                v-model="consumerunit.person_type"
                label=""
                :rules="[(v) => !!v || 'Por favor, informe o Tipo de Pessoa!']"
                :hint="'Informe o Tipo de Pessoa'"
                row
                @change="getPlansByParams({ person_type: $event })"
              >
                <v-radio label="Pessoa Física" value="pf"></v-radio>
                <v-radio label="Pessoa Jurídica" value="pj"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                id="customer_cpf"
                v-model.trim="consumerunit.cpf"
                autofocus
                :label="consumerunit.person_type === 'pf' ? 'CPF' : 'CNPJ'"
                :mask="
                  consumerunit.person_type === 'pf'
                    ? '###.###.###-##'
                    : '##.###.###/####-##'
                "
                append-outer-icon="autorenew"
                @click:append-outer="buscaUcsCemig(consumerunit.cpf, false)"
                :rules="
                  consumerunit.person_type === 'pf'
                    ? [
                        (v) =>
                          (v && v.length >= 11) || 'Preencha o CPF Completo',
                        (v) =>
                          this.validCPFCNPJ(
                            this.consumerunit.cpf,
                            this.consumerunit.person_type,
                          ) === true || 'CPF inválido',
                      ]
                    : [
                        (v) =>
                          (v && v.length >= 14) || 'Preencha o CNPJ Completo',
                        (v) =>
                          this.validCPFCNPJ(
                            this.consumerunit.cpf,
                            this.consumerunit.person_type,
                          ) === true || 'CNPJ inválido',
                      ]
                "
                @change="buscaUcsCemig($event)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-autocomplete
                :items="plans"
                item-text="name"
                label="Plano"
                v-model.lazy="plan"
                :rules="notEmptyRule"
                required
                return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex v-if="qualifications && qualifications.length > 0">
              <v-list three-line>
                <template v-for="(qualification, idx) in qualifications">
                  <qualifying-card
                    :key="idx"
                    :qualification="qualification"
                    v-if="qualification.status === 'pending'"
                  />
                  <not-qualified-card
                    :key="idx"
                    :qualification="qualification"
                    v-if="
                      qualification.status === 'bill_not_found' ||
                      qualification.status === 'error'
                    "
                  />
                  <disqualified-card
                    :key="idx"
                    :qualification="qualification"
                    v-if="qualification.status === 'disqualified'"
                  />
                  <qualified-card
                    :key="idx"
                    :qualification="qualification"
                    v-if="qualification.status === 'qualified'"
                  />
                </template>
              </v-list>
            </v-flex>
            <v-flex xs12 md12 text-xs-right>
              <v-btn
                class="mx-2 font-weight-light"
                color="green lighten-1"
                :loading="loading"
                :disabled="
                  !qualifications ||
                  qualifications.length < 1 ||
                  qualifications[0].status !== 'qualified' ||
                  loading
                "
                @click.prevent="endQualification"
              >
                <v-icon left dark>add</v-icon>
                Salvar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </material-card>
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
    <v-dialog v-model="dialog_cpf" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ label_loading_cpf }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_ucs" persistent max-width="500px">
      <v-card>
        <v-card-title> Unidades Consumidoras do Cliente na Cemig </v-card-title>
        <v-card-text>
          <v-list subheader three-line>
            <v-subheader
              >Selecione a unidade consumidora que o membro quer
              contratar.</v-subheader
            >
            <v-list-tile v-for="uc in ucs_cemig" :key="uc.installation_number">
              <v-list-tile-action>
                <v-radio-group v-model="uc_selected" label="">
                  <v-radio :value="uc.installation_number"></v-radio>
                </v-radio-group>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  uc.installation_number
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ uc.address }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog_ucs = false"
            >fechar</v-btn
          >
          <v-btn
            color="blue darken-1"
            :loading="loading"
            :disabled="loading"
            @click.prevent="createQualification"
            >Selecionar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import firestore from "../../firebase/firestore";
import { eventBus } from "../../main";
import { getCPFCemig } from "../../services/getCPFCemig";
import { validaCPF, validaCNPJ } from "../../services/users";
import { mapState, mapActions, mapGetters } from "vuex";
import {
  initQualification,
  finishQualification,
} from "../../services/qualification";
import QualifiedCard from "../sales/qualification/QualifiedCard.vue";
import DisqualifiedCard from "../sales/qualification/DisqualifiedCard.vue";
import QualifyingCard from "../sales/qualification/QualifyingCard.vue";
import NotQualifiedCard from "../sales/qualification/NotQualifiedCard.vue";

export default {
  components: {
    QualifiedCard,
    DisqualifiedCard,
    QualifyingCard,
    NotQualifiedCard,
  },

  data() {
    return {
      dialog_cpf: false,
      dialog_ucs: false,
      user: {},
      user_id: null,
      rules: [],
      consumerunit: {
        id: "",
        cpf: null,
        person_type: null,
      },
      snack: {
        color: null,
        top: true,
        bottom: false,
        left: false,
        right: false,
        snackMessage: "",
        snackbar: false,
      },
      loading: false,
      type: "new",
      valid: false,
      notEmptyRule: [(v) => !!v || "Por favor, esse dado é obrigatório."],
      agent_email: null,
      qualification_ids: [],
      plan: null,
      label_loading_cpf: "Validando CPF informado",
      ucs_cemig: [],
      uc_selected: null,
    };
  },

  created() {
    if (this.$route.params.id) {
      this.user_id = this.$route.params.id;
      firestore
        .collection("users")
        .doc(this.user_id)
        .get()
        .then((ret_doc) => {
          this.user = {
            id: ret_doc.id,
            ...ret_doc.data(),
          };
          let params = {
            person_type: this.user.person_type || "pf",
          };
          this.consumerunit.person_type = params.person_type;
          this.getPlansByParams(params);
          if (this.user.plan) {
            this.plan = this.user.plan;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
    this.agent_email = this.loggedUser?.email || null;
    eventBus.$on("consumerunit_auto", async (consumerunit) => {
      this.resetState();
      this.consumerunit = consumerunit.data || {};
      this.type = consumerunit.type;
    });
    if (!this.consumerunit && !this.consumerunit.person_type)
      this.consumerunit.person_type = this.user.person_type || "pf";
  },

  computed: {
    ...mapState("sales", ["plans"]),
    ...mapGetters("qualification", ["qualifications"]),
    ...mapGetters(["loggedUser"]),
  },

  methods: {
    ...mapActions("qualification", ["resetState", "getQualifications"]),
    ...mapActions("sales", ["getPlansByParams"]),

    validCPFCNPJ(value, type) {
      if (type === "pf") return validaCPF(value);
      else return validaCNPJ(value);
    },

    async buscaUcsCemig(cpf) {
      this.dialog_cpf = true;
      if (
        cpf && cpf !== "" && this.consumerunit.person_type === "pf"
          ? validaCPF(cpf)
          : validaCNPJ(cpf)
      ) {
        this.label_loading_cpf = "Buscando dados do membro na CEMIG...";
        await getCPFCemig(cpf)
          .then((ret) => {
            if (ret.status === 200) {
              this.ucs_cemig = ret.data;
              this.dialog_ucs = true;
            } else {
              this.show_snack(
                "Atenção: CPF não encontrado no site da CEMIG, validar se o CPF informado é do titular da conta.",
                "warning",
                "bottom",
              );
              this.valid = false;
            }
          })
          .catch((err) => {
            console.error(err);
            this.show_snack(
              `Erro ao buscar dados na CEMIG. ${
                err && err.response ? err.response.data : ""
              }`,
              "warning",
              "bottom",
            );
          });
      }
      this.dialog_cpf = false;
    },

    async createQualification() {
      this.loading = true;
      await initQualification(
        this.consumerunit.cpf,
        this.user_id,
        [this.uc_selected],
        "super_auto",
        false,
        null,
        null,
        null,
        this.agent_email,
      )
        .then(async (ret) => {
          if (ret.status === 200) {
            this.qualification_ids = ret.data.ids;
            const params = {
              cpf: this.consumerunit.cpf,
              qualification_ids: this.qualification_ids,
            };
            await this.getQualifications(params);
            this.dialog_ucs = false;
          } else {
            this.show_snack(
              "Erro ao iniciar qualificação.",
              "warning",
              "bottom",
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.show_snack("Erro ao iniciar qualificação.", "warning", "bottom");
        });
      this.loading = false;
    },

    async endQualification() {
      const percentage_discount = this.custom_percentage_discount_enable
        ? this.custom_percentage_discount
        : null;
      const unique_billing = this.custom_unique_billing_enable
        ? this.custom_unique_billing
        : null;
      const power_plant = this.custom_power_plant_enable
        ? this.custom_power_plant
        : null;
      const plan = {
        contract_time: this.plan.contract_time,
        id: this.plan.id,
        name: this.plan.name,
        discount: this.plan.discount,
      };
      this.loading = true;
      await finishQualification(
        this.consumerunit.cpf,
        this.user_id,
        this.qualification_ids,
        percentage_discount,
        unique_billing,
        power_plant,
        plan,
        "super_auto",
        this.agent_email,
      )
        .then((ret) => {
          if (ret.status === 200) {
            let result = ret.data.results[ret.data.results.length - 1];
            let uc_added = !result ? false : result.consumer_unit_added;
            if (!uc_added) {
              this.show_snack(
                "Erro ao adicionar unidade consumidora! " + result.message,
                "warning",
                "bottom",
              );
            } else {
              this.show_snack(
                "Unidade consumidora adicionada com sucesso!",
                "green ligthen-1",
                "bottom",
              );
            }
            console.log("Qualificação finalizada");
          } else {
            this.show_snack(
              "Erro ao adicionar unidade consumidora! " + ret.data,
              "error",
              "bottom",
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.show_snack(
            `Erro ao adicionar unidade consumidora! ${
              err && err.response ? err.response.data : ""
            }`,
            "error",
            "bottom",
          );
        });
      this.loading = false;
      this.clearForm();
    },

    show_snack(message, color, ...args) {
      this.snack.top = false;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },

    clearForm() {
      this.consumerunit.id = null;
      this.consumerunit.cpf = null;
      this.resetState();
      this.$refs.form.resetValidation();
    },
  },
};
</script>
